import { useQuery } from '@tanstack/react-query'
import { queryNames } from '../../queries'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { SearchListOptionsDto } from '../../../api/data/types'
import { showErrorToast } from '../../../utils/errors'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { mapTrainingRoomListDto } from '../../../mapping/rooms'
import { RoomList } from '../../../types/rooms'

const dataApi = DataApi.getInstance()

type Options = {
  enabled: boolean
  onSuccess: (data: RoomList) => void
}

export default function useGetPlaceTrainingRoomList(uuid: string, options: SearchListOptionsDto & Options) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getRoomList, uuid, options.search, options.limit, options.offset], async () => {
    const { data } = await dataApi.getPlaceTrainingRoomList(uuid, options)
    return mapTrainingRoomListDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    enabled: options.enabled,
    onSuccess: options.onSuccess,
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
